(function(angular, undefined) {
'use strict';

angular.module('pulianiBookStoreApp.constants', [])

.constant('appConfig', {userRoles:['guest','customer','admin']})

;
})(angular);